//mui
import {Theme} from '@mui/material';

export const MuiStepConnector = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => {
			return {
				'.MuiStepConnector-line': {
					borderColor: theme.palette.neutral100,
					borderRadius: 'var(--default--border-radius)',
					borderWidth: '4px',
				},

				'&.Mui-active, &.Mui-completed': {
					'.MuiStepConnector-line': {
						borderColor: theme.palette.primary500,
					},
				},
			};
		},
	},
};
